import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  StyledModal,
  StyledTitle,
  StyledBody,
  ManageAnniversariesContainer,
  ToggleButton,
  Button,
} from "./styles";
import { AdminLeftArrowIcon, RecognitionAnniversaryIcon, RecognitionBirthdayIcon, RecognitionCloseIcon, RecognitionTickIcon } from "../../../utils/icons";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import { GetBirthdayAndAnniversaryCardStatus, PutBirthdayAndAnniversaryCardToggle } from "../../../redux/constants/apiConstants";
import CommonModal from "../../common/CommonModal/CommonModal";
import AniBiPointsModal from "./aniBiPointsModal";

const ManageAnniversaryPopup = ({ showModal, onClose, companyId }) => {
  // const [/*isLoading,*/ setIsLoading] = useState(false);
  const [isBirthday, setIsBirthday] = useState(false);
  const [isAnniversary, setIsAnniversary] = useState(false);

  const [existingIsBirthday, setIsBirthdayExisting] = useState(false);
  const [existingIsAnniversary, setIsAnniversaryExisting] = useState(false);

  const [nextModal, setNextModal] = useState(false);
  const [showManagePopup, setShowManagePopup] = useState(true);
  const [showPointsModal, setshowPointsModal] = useState(false);
  const [anniversaryPoint, setAnniversaryPoint] = useState(null);
  const [birthdayPoint, setBirthdayPoint] = useState(null);
  const [isEdited, setIsEdited] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdateBirthdayPoints, setisUpdateBirthdayPoints] = useState(false);
  const [isUpdateAnniversaryPoints, setisUpdateAnniversaryPoints] = useState(false);


  useEffect(() => {
    getDetails()
  }, [])

  const handleToggle = (e) => {
    const { name, checked } = e.target;
    if (name === "isBirthday") {
      setIsBirthday(checked);
    } else if (name === "isAnniversary") {
      setIsAnniversary(checked);
    }
    setIsEdited(true);
  };

  const saveChanges = async () => {
    // setIsLoading(true);

    const payload = {
      company_id: companyId,
      show_birthday_card: isBirthday ? 1 : 0,
      show_work_anniversary_card: isAnniversary ? 1 : 0,
      birthday: Number(birthdayPoint) ? Number(birthdayPoint) : 0,
      anniversary: Number(anniversaryPoint) ? Number(anniversaryPoint) : 0
    };

    try {
      const res = await fetchApi(PutBirthdayAndAnniversaryCardToggle, "PUT", payload);
      if (res.status === "success") {
        toast.success("Settings updated successfully!");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      // setIsLoading(false);
    }
  };

  const getDetails = async () => {
    // setIsLoading(true);

    try {
      const res = await fetchApi(GetBirthdayAndAnniversaryCardStatus + companyId, "GET");
      if (res.status === "success") {
        // toast.success("Settings updated successfully!");
        const { show_work_anniversary_card, show_birthday_card, anniversary_point, birthday_point, update_birthday_point_status, update_anniversary_point_status } = res.data[0]
        setIsAnniversary(show_work_anniversary_card);
        setIsBirthday(show_birthday_card);

        setIsBirthdayExisting(show_birthday_card);
        setIsAnniversaryExisting(show_work_anniversary_card);

        setAnniversaryPoint(anniversary_point);
        setBirthdayPoint(birthday_point);
        setisUpdateBirthdayPoints(update_birthday_point_status);
        setisUpdateAnniversaryPoints(update_anniversary_point_status);

        if (update_birthday_point_status && update_anniversary_point_status) {
          setIsUpdate(true);
        } else {
          setIsUpdate(false);
        }

      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      // setIsLoading(false);
    }
  };

  const handleSkip = () => {
    (existingIsBirthday != isBirthday || existingIsAnniversary != isAnniversary) && saveChanges();
    setNextModal(false);
  }

  const setPointValues = () => {
    setNextModal(false);
    setshowPointsModal(true);
  }

  const onNextClick = () => {
    if (isEdited && (!isAnniversary && !isBirthday)) {
      saveChanges();
    } else {
      setNextModal(true);
    }
    setShowManagePopup(false);
  }

  return (
    <>
      {showManagePopup && <StyledModal show={showModal} newWidth="400px" newBg="newBg" /*newHeight="352px"*/ display="none">
        <Modal.Header closeButton onHide={onClose} style={{ background: "white" }}>
          <StyledTitle>Manage Anniversaries</StyledTitle>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            {RecognitionCloseIcon()}
          </div>
        </Modal.Header>

        <StyledBody>
          <ManageAnniversariesContainer marginTopToggle="8px">
            <div className="first-text">
              Would you like to manage anniversaries by turning them on or off for your company?
            </div>
            {/* <div className="second-text">
              Note: By making changes here, all admins will receive a notification about this update.
            </div> */}

            <div className="toggle-container">
              <div className="icon">
                <span className="icon-container">{RecognitionAnniversaryIcon()}</span>
                <span className="name">Work</span>
              </div>
              <div className="toggle">
                <ToggleButton>
                  <label className="switch">
                    <input type="checkbox" name="isAnniversary" checked={isAnniversary} onChange={handleToggle} />
                    <span className="slider round"></span>
                  </label>
                </ToggleButton>
              </div>
            </div>

            <div className="toggle-container">
              <div className="icon">
                <span className="icon-container">{RecognitionBirthdayIcon()}</span>
                <span className="name">Birthdays</span>
              </div>
              <div className="toggle">
                <ToggleButton>
                  <label className="switch">
                    <input type="checkbox" name="isBirthday" checked={isBirthday} onChange={handleToggle} />
                    <span className="slider round"></span>
                  </label>
                </ToggleButton>
              </div>
            </div>
          </ManageAnniversariesContainer>
   
          <Button isWidth="151px" isHeight="40px" background="#F37A65" color="white" onClick={()=>isEdited ||  isAnniversary || isBirthday ? onNextClick() : onClose()} disabled={!isEdited}>
            { (!isAnniversary && !isBirthday) ?  "Done" : isEdited ? "Next" : "Next"}
            <div style={{marginLeft:"8px"}}> {(!isAnniversary && !isBirthday) ? RecognitionTickIcon("white") : <AdminLeftArrowIcon rotate={180} color={"white"}/>}</div> 
          </Button>
        </StyledBody>
      </StyledModal>}

      {nextModal && <CommonModal
        show={nextModal}
        // icon={null}
        title={(!isUpdateBirthdayPoints && !isUpdateAnniversaryPoints) ? "Adding Points" : "Edit Points"}
        description={`Would you like to ${isUpdate ? 'update' : 'include'} points for ${(isAnniversary && isBirthday) ? "birthdays and work anniversaries" : isAnniversary ? "work anniversaries" : isBirthday ? "birthdays" : ""}? `}
        onCancel={handleSkip}
        onClose={() => setNextModal(false)}
        onConfirm={setPointValues}
        cancelText={(!isUpdateBirthdayPoints && !isUpdateAnniversaryPoints) ? "Skip" : "No, Keep It As Is"}
        confirmButtonText={`Yes, ${(!isUpdateBirthdayPoints && !isUpdateAnniversaryPoints) ? "Add" : "Update"} Points`}
        // buttonIcon={RestoreIcon()}
        modalHeight={'auto'}
        confirmButtonWidth="148px"
        saveChanges={saveChanges}
        note={"Note: You can only add & update this once per year."}
      />
      }
      {showPointsModal && <AniBiPointsModal isAnniversary={isAnniversary} isBirthday={isBirthday} companyId={companyId} showModal={showPointsModal} onClose={onClose} anniversaryPoint={anniversaryPoint} birthdayPoint={birthdayPoint} title={isUpdate ? "Edit Points" : "Adding Points"} isUpdateBirthdayPoints={isUpdateBirthdayPoints} isUpdateAnniversaryPoints={isUpdateAnniversaryPoints} />}
    </>
  );
};

ManageAnniversaryPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyId: PropTypes.number,
};

const mapStateToProps = (state) => ({
  userId: state.profileData.userId,
});

export default connect(mapStateToProps, null)(ManageAnniversaryPopup);